var indentation_default = {
  "indentZero": "iCJIo",
  "indentOne": "-KaWT",
  "indentTwo": "W4qqt",
  "indentThree": "_9Y0fq",
  "indentFour": "Xgoqr",
  "indentFive": "a-quj",
  "indentSix": "HtCIT"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
